/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-console */
import SelectorEngine from '../../../utils/dom/selector-engine';
import Manipulator from '../../../utils/dom/manipulator';
import Request from '../../../utils/request';

const SELECTOR_MAIN_DIV = '.js-course-providers-notifications-wrapper';
const STORAGE_KEY = 'CPC_Read_Notifications';

class CourseProvidersNotifications {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_MAIN_DIV);
		if (!this._wrapper) return;
		this._activitiesApiUrl = Manipulator.getDataAttribute(this._wrapper, 'activities-api-url');
		this._classDetailsPageUrl = Manipulator.getDataAttribute(this._wrapper, 'class-details-page-url');
		this._notificationsOpener = SelectorEngine.findOne('.js-course-providers-notifications-opener', this._wrapper);
		this._notificationsArea = SelectorEngine.findOne('.js-course-providers-notifications-area', this._wrapper);
		this._badge = SelectorEngine.findOne('.js-course-providers-notifications-badge', this._wrapper);
		this._activities = [];
		this._fetching = false;
		this._isOpen = false;
		const deferEvent = Manipulator.getDataAttribute(this._wrapper, 'defer-event');
		if (deferEvent) {
			document.addEventListener(deferEvent, () => this._fetchActivities(), { once: true });
		} else {
			this._fetchActivities();
		}
		this._bindEvents();
	}

	_bindEvents() {
		this._notificationsOpener.addEventListener('click', () => this._toggle());
		document.addEventListener('click', (e) => {
			if (this._isOpen && !this._wrapper.contains(e.target)) this._close();
		});
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && this._isOpen) this._close();
		});
	}

	_toggle() {
		this._isOpen ? this._close() : this._open();
	}

	_open() {
		this._isOpen = true;
		this._notificationsArea.hidden = false;
		this._notificationsArea.classList.add('is-open');
		this._notificationsOpener.setAttribute('aria-expanded', 'true');
		this._markAsRead();
		this._renderActivities();
		this._notificationsArea.focus();
	}

	_close() {
		this._isOpen = false;
		this._notificationsArea.classList.remove('is-open');
		this._notificationsArea.hidden = true;
		this._notificationsOpener.setAttribute('aria-expanded', 'false');
		this._notificationsOpener.focus();
	}

	_renderActivities() {
		if (this._fetching) {
			this._notificationsArea.innerHTML = '<p class="u-p-3 u-text-center">Fetching...</p>';
			return;
		}
		if (!this._activities.length) {
			this._notificationsArea.innerHTML = '<p class="u-p-3 u-text-center">No notifications</p>';
			return;
		}
		this._notificationsArea.innerHTML = `
			<ul class="p-course-providers__notifications-list" role="list">
				${this._activities
					.map(
						(item) => `
						<li class="p-course-providers__notifications-item">
							<a class="p-course-providers__notifications-link" href="${this._classDetailsPageUrl}?classId=${item.classId}">
								<span class="u-label2">${item.attendeeName || ''} booked onto</span>
								<h2 class="u-title4">${item.courseName || ''}</h2>
								<span>${item.createdDate ? new Date(item.createdDate).toLocaleDateString('en-GB') : ''}</span>
							</a>
						</li>`
					)
					.join('')}
			</ul>
		`;
	}

	_updateBadge() {
		if (!this._badge) return;
		const stored = localStorage.getItem(STORAGE_KEY);
		const readCount = stored && stored !== 'undefined' ? JSON.parse(stored).length : 0;
		const unread = Math.max(this._activities.length - readCount, 0);
		if (unread > 0) {
			this._badge.textContent = unread;
			this._badge.hidden = false;
			this._notificationsOpener.setAttribute('aria-label', `Notifications (${unread} unread)`);
		} else {
			this._badge.hidden = true;
			this._notificationsOpener.setAttribute('aria-label', 'Notifications');
		}
	}

	_markAsRead() {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(this._activities));
		this._updateBadge();
	}

	async _fetchActivities() {
		try {
			this._fetching = true;
			const response = await Request.get(this._activitiesApiUrl, {});
			const { bookingActivityItems } = response.responseContainerContents;
			this._activities = bookingActivityItems || [];
		} catch (error) {} finally {
			this._fetching = false;
			this._updateBadge();
			this._renderActivities();
		}
	}
}

const globalCourseProvidersNotifications = new CourseProvidersNotifications();
export default globalCourseProvidersNotifications;
